module.exports = __webpack_public_path__ + "static/media/400391_01.98323282.png";